<template>
  <div>

    <div class="card card-info" v-if="courses.length > 0">
      <div class="card-header with-border">
        <h3 class="card-title">Course Registration Request Form</h3>
      </div>
      <!-- /.box-header -->
      <!-- form start -->
      <div class="row">
        <div class="col-md-12" style="padding-right: 2%; padding-left: 2%; padding-top: 1%">
          <!-- Custom Tabs -->
          <div class="nav-tabs-custom">
            <ul class="nav nav-tabs" style="font-family: Calibri; font-size: 14px;">
              <li class="active"><a href="#tab_1" data-toggle="tab" aria-expanded="true">Request Detail</a></li>
              <li class=""><a href="#tab_2" data-toggle="tab" aria-expanded="false">Current Semester History</a></li>
            </ul>
            <div class="tab-content">
              <div class="tab-pane active" id="tab_1">
                <div class="row">
                  <div class="col-md-9">
                    <div class="row">
                      <div class="col-md-4">
                        <div class="form-group">
                          <label>Req No.</label>
                          <input class="form-control" disabled v-model="req.RequestNo" />
                        </div>
                      </div>

                      <div class="col-md-4">
                        <div class="form-group">
                          <label>Req Date</label>
                          <input class="form-control" disabled v-model="req.RequestDate" />
                        </div>
                      </div>

                      <div class="col-md-4">
                        <div class="form-group">
                          <label>Roll No.</label>
                          <input class="form-control" disabled v-model="st.RollNo" />
                        </div>
                      </div>

                      <div class="col-md-4">
                        <div class="form-group">
                          <label>Registration No.</label>
                          <input class="form-control" disabled v-model="st.RegistrationNo" />
                        </div>
                      </div>

                      <div class="col-md-4">
                        <div class="form-group">
                          <label>Student Name</label>
                          <input class="form-control" disabled v-model="st.Name" />
                        </div>
                      </div>

                      <div class="col-md-4">
                        <div class="form-group">
                          <label>Mobile No.</label>
                          <input class="form-control" disabled v-model="st.MobileNo" />
                        </div>
                      </div>

                      <div class="col-md-8">
                        <div class="form-group">
                          <label>Batch</label>
                          <input class="form-control" disabled v-model="st.Batch" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <br />
                    <!--<img class="img-thumbnail pull-right" style="height: 170px;" src="../Images/icon-profile.png" />-->
                  </div>
                </div>
                <div class="row" style="margin-top: 7px">
                  <div class="col-md-12">
                    <table style="width: 100%;" id="myTable2" class="table table-bordered table-color">
                      <thead class="bg-info">
                        <tr>
                          <th>Batch </th>
                          <th>Courses</th>
                          <th>Course Type</th>
                          <th>Action</th>
                          <th>Remarks</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index) in courses">
                          <td style="vertical-align: middle">{{item.Batch}}</td>
                          <td style="vertical-align: middle">
                            <label class="custom-control-label" v-bind:for="index + 'c'">
                              {{item.CourseCode}} - {{item.CourseName}}
                              <span v-if="item.RequestType == 'Add'" class="badge badge-pill bg-green">Add</span>
                              <span v-else-if="item.RequestType == 'Drop'" class="badge badge-pill bg-red">Drop</span>
                              <br />
                              <small>Theory Cr. {{item.Theory}} | Lab Cr. {{item.Lab}}</small>
                            </label>
                          </td>
                          <td style="vertical-align: middle">{{item.Type}}</td>
                          <td style="vertical-align: middle">
                            <div class="checkbox">
                              <label>
                                <input style="margin-top: 0;" type="checkbox" value="true" v-model="item.ApprovalStatus">
                                <strong>Approve</strong>
                              </label>
                            </div>
                          </td>
                          <td style="vertical-align: middle">
                            <input class="form-control" v-model="item.ApprovalRemarks" />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <!-- /.tab-pane -->

              <div class="tab-pane" id="tab_2">
                <div class="row">
                  <div class="col-md-12">
                    <table style="width: 100%;" class="table table-bordered table-color">
                      <thead class="bg-info">
                        <tr>
                          <th>Batch </th>
                          <th>Courses</th>
                          <th>Course Type</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index) in history">
                          <td style="vertical-align: middle">{{item.Batch}}</td>
                          <td style="vertical-align: middle">
                            <label class="custom-control-label" v-bind:for="index + 'c'">
                              {{item.CourseCode}} - {{item.CourseName}}

                              <br />
                              <small>Theory Cr. {{item.Theory}} | Lab Cr. {{item.Lab}}</small>
                            </label>
                          </td>
                          <td style="vertical-align: middle">{{item.Type}}</td>
                          <td style="vertical-align: middle">
                            <span class="text-success"><strong>{{item.Enrolled}}</strong></span>
                            <br />
                            <span class="text-danger"><strong>{{item.Droped}}</strong></span>
                          </td>
                        </tr>
                      </tbody>
                    </table>

                  </div>
                </div>
              </div>

              <!-- /.tab-pane -->
            </div>
            <!-- /.tab-content -->
          </div>
          <!-- nav-tabs-custom -->
        </div>
      </div>
      <div class="card-footer text-right">
        <button class="btn btn-success" type="button" v-on:click="save()">Save</button>
        <button class="btn btn-danger" type="button" v-on:click="clear()">Cancel</button>
      </div>
    </div>

    <div class="card card-info" v-else>
      <div class="card-header with-border">
        <h3 class="card-title">
          Course Registration Requests
        </h3>
      </div>
      <div style="padding-right: 1%; padding-left: 1%; padding-bottom: 1%; padding-top: 1%;">
        <div class="row" style="margin-top: 5px;">
          <div class="col-md-12 col-sm-12">
            <table id="tbl" class="table table-bordered table-color">
              <thead class="bg-info">
                <tr>
                  <th>Request No.</th>
                  <th>Request Date</th>
                  <th>Roll No.</th>
                  <th>Student Name</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in requests">
                  <td>{{item.RequestNo}}</td>
                  <td>{{item.RequestDate}}</td>
                  <td>{{item.RollNo}}</td>
                  <td>{{item.StudentName}}</td>
                  <td>{{item.Status}}</td>
                  <td>
                    <button v-if="item.Status != 'Approved'" class="btn btn-info btn-block" type="button" v-on:click="edit(item.RequestNo)">Edit</button>
                    <button v-if="item.Status == 'Approved'" class="btn btn-success btn-block" type="button" v-on:click="view(item.RequestNo)">View</button>
                  </td>
                </tr>
              </tbody>
            </table>

          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div id="myModal" class="modal fade" role="dialog">
      <div class="modal-dialog modal-lg">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Details</h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <table style="width: 100%;" class="table table-bordered table-color">
                  <thead class="bg-info">
                    <tr>
                      <th>Batch </th>
                      <th>Courses</th>
                      <th>Course Type</th>
                      <th>Status</th>
                      <th>Remarks</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in allcourses">
                      <td style="vertical-align: middle">{{item.Batch}}</td>
                      <td style="vertical-align: middle">
                        <label class="custom-control-label" v-bind:for="index + 'c'">
                          {{item.CourseCode}} - {{item.CourseName}}
                          <span v-if="item.RequestType == 'Add'" class="badge badge-pill bg-green">Add</span>
                          <span v-else-if="item.RequestType == 'Drop'" class="badge badge-pill bg-red">Drop</span>
                          <br />
                          <small>Theory Cr. {{item.Theory}} | Lab Cr.  {{item.Lab}}</small>
                        </label>
                      </td>
                      <td style="vertical-align: middle">{{item.Type}}</td>
                      <td style="vertical-align: middle">
                        <strong class="text-success" v-if="item.ApprovalStatus">Approved</strong>
                        <strong v-else class="text-danger">Dis-Approved</strong>
                      </td>
                      <td style="vertical-align: middle">{{item.ApprovalRemarks}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  const axios = require('axios').default;
  export default ({
    data() {
      return {
        requests: [],
        req: { RequestNo: '', RequestDate: '' },
        courses: [],
        history: [],
        st: { RollNo: '', RegistrationNo: '', StudentName: '', Batch: '', MobileNo: '' },
        allcourses: [],
      }
    },
    created: function () {
      this.loadRequests();
    },

    updated: function () {
      $('#tbl').DataTable();
    },

    methods:
    {
      loadRequests() {
        var vm = this;
        startReq();
        axios.post('/api/DCApi/loadRequests')
          .then(function (response) {
            vm.requests = response.data.l;
            endReq();
          })
      },

      edit(no) {
        var vm = this;
        startReq();
        axios.post('/api/DCApi/editRequest?id=' + no)
          .then(function (response) {
            vm.courses = response.data.courses;
            vm.history = response.data.his;
            vm.st = response.data.st;
            vm.req.RequestNo = vm.courses[0].RequestNo;
            vm.req.RequestDate = vm.courses[0].RequestDate;
            endReq();
          });
      },

      clear() {
        this.req = { RequestNo: '', RequestDate: '' },
          this.courses = [],
          this.history = [],
          this.st = { RollNo: '', RegistrationNo: '', StudentName: '', Batch: '', MobileNo: '' }
      },

      save() {
        var vm = this;
        startReq();
        axios.post('/api/DCApi/saveRequest', {
          courses: vm.courses
        })
          .then(function (res) {
            if (res.data.status) {
              toastr.success("Saved Successfully", "Done!");
              vm.clear();
              endReq();
            }
            else {
              endReq();
              toastr.error(res.data.msg);
            }
          });
      },

      view(no) {

        $('#myModal').modal('show');
        var vm = this;
        startReq();
        axios.post('/api/DCApi/viewRequest?id=' + no)
          .then(function (response) {
            vm.allcourses = response.data.crs;
            endReq();
          });
      }
    }
  })
</script>



// WEBPACK FOOTER //
// src/components/DC/courseRegistrationRequest.vue